import styled from 'styled-components'
import TrashSvg from '../../../static/images/icons/icon_trash_red_outline.svg'
import { H3, P2 } from '../../styled/typography/typography'

export const Alert = styled.div`
  text-align: center;
  font-size: 13px;
`

export const TrashIcon = styled.img.attrs({
  src: TrashSvg
})`
  width: 24px;
  height: 29px;
`

export const AlertWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  color: #000;
`

export const CancelButton = styled.button`
  border: none;
  box-shadow: none !important;

  &:hover {
    border: none;
    box-shadow: none !important;
  }
`

export const Header = styled(H3)`
  margin-top: 20px;
`

export const SkillName = styled(H3)`
  margin-left: 15px;
`
